import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { TicketStatus } from '@resident-nx/shared';
import { TranslatePipe } from '@ngx-translate/core';

type ClassAndText = {
  text: string;
  color: string;
};

const StatusClassesAndTextObj: Partial<Record<TicketStatus, ClassAndText>> = {
  [TicketStatus.OPEN]: {
    color: 'var(--im-color-info)',
    text: 'ticket_status.open_l',
  },
  [TicketStatus.IN_PROGRESS]: {
    color: 'var(--im-color-moderate)',
    text: 'ticket_status.in-progress_l',
  },
  [TicketStatus.WAITING_FOR_OTHERS]: {
    color: 'var(--im-color-moderate)',
    text: 'ticket_status.waiting-for-others_l',
  },
  [TicketStatus.CLOSED]: {
    color: 'var(--im-color-positive)',
    text: 'ticket_status.closed_l',
  },
  [TicketStatus.CANCELLED]: {
    color: 'var(--im-color-grey)',
    text: 'ticket_status.cancelled_l',
  },
};

@Component({
  selector: 'rs-web-status-badge',
  templateUrl: './status-badge.component.html',
  styleUrls: ['./status-badge.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslatePipe],
  host: {
    '[style.--bg-color]': 'this.status().color',
  },
})
export class StatusBadgeWebComponent {
  readonly state = input.required<TicketStatus>();
  readonly status = computed(() => StatusClassesAndTextObj[this.state()]);
  readonly text = computed(() => this.status().text);
}
